import { schema } from "normalizr";

import { ApiModel } from "./model";
import { Album, Artist, Track, NAlbum, NArtist, NTrack } from "./music";

interface Chart extends ApiModel {
    kind: "chart";
    name: string;
    // Relations
    rows: ChartRow[];
}

interface ChartRow {
    isrc?: string;
    upc?: string;
    album_id?: number;
    track_id?: number;
    artist_id?: number;
    album?: Album | number;
    track?: Track | number;
    artist?: Artist | number;
    streams: {
        total: number;
        vendor: {
            [key: string]: number;
        };
    };
}

// Define the normalised version of charts.
const NChartRow = new schema.Entity("chartRows", {
    track: NTrack,
    album: NAlbum,
    artist: NArtist,
}, {
    idAttribute: (value: ChartRow, parent: Chart, key: string) => {
        return parent.name + "_" + parent.rows.indexOf(value);
    },
    processStrategy: (value: ChartRow, parent: Chart, key: string) => {
        return {...value, id: parent.name + "_" + parent.rows.indexOf(value)};
    },
});
const NChart = new schema.Entity("charts", {
    rows: [NChartRow],
}, {
    idAttribute: "name",
});
// Need separate schemas for denormalising.
const DChartRow = new schema.Entity("chartRows");
const DChart = new schema.Entity("charts", {
    rows: [DChartRow],
}, {
    idAttribute: "name",
});

interface ChartsNormalisedEntities {
    charts?: {
        [key: string]: Chart;
    };
}

export {
    Chart,
    ChartRow,
    NChart,
    DChart,
    ChartsNormalisedEntities,
};
